import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  UpdateBackofficeKnowledgeCompanyResponseDataSchema,
  UpdateBackofficeKnowledgeCompanySchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpdateBackofficeKnowledgeCompanyResponseDataSchema>>

export function useUpdateBackofficeKnowledgeCompanyMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      companyId,
      ...body
    }: z.infer<typeof UpdateBackofficeKnowledgeCompanySchema> & { companyId: string }) => {
      const { data } = await axios.patch<Response>(
        `/backoffice/knowledge/companies/${companyId}`,
        body,
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["backofficeKnowledgeOverview"] })
    },
  })
}
